import { IActionResponse, IActionResult, BaseClient, IPagedResult } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { GridRoleDto, RoleDto, SearchRoleDto } from "../../dto";

export class RoleClient extends BaseClient {
    routes = ["account", "Role"];

    async getRoleAsync(id?: string | undefined): Promise<RoleDto> {
        const actions: string[] = ["GetRole"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        const result: RoleDto = await this.getAsync<RoleDto>(actions, params);
        return result;
    }

    async getRolesAsync(): Promise<RoleDto[]> {
        const actions: string[] = ["GetAllRoles"];

        const result: RoleDto[] = await this.getAsync<RoleDto[]>(actions);
        return result;
    }

    async searchRolesAsync(payload: SearchRoleDto | undefined): Promise<IPagedResult<GridRoleDto>> {
        const actions: string[] = ["SearchRoles"];
        const result: IPagedResult<GridRoleDto> = await this.postAsync<SearchRoleDto, GridRoleDto, IPagedResult<GridRoleDto>>(actions, payload);
        return result;
    }

    async saveRoleAsync(payload: RoleDto | undefined): Promise<IActionResult<RoleDto>> {
        const actions: string[] = ["SaveRole"];
        return await this.postAsync<RoleDto>(actions, payload);
    }

    async deleteRoleAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteRole"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        return await this.deleteAsync(actions, params);
    }
}
